import { gql } from '@apollo/client';

const GET_USER_OBSERVATION_REPORTS_COUNT = gql`
  query GetUserObservationReportsCount($externalUserId: Int!) {
    userObservationReportsCount(externalUserId: $externalUserId)
  }
`;

export default GET_USER_OBSERVATION_REPORTS_COUNT;
